import React from 'react';
import _ from "lodash";
import images, { FileInvoiceDollarIcon } from '../../images';
import {REAL_ESTATE_TYPES} from "../../components/AssetModal/constants";
import MortageIcon from "../../images/RiskProfiling/assets_icons/MortageIcon";
import OtherLiabilitiesIcon from "../../images/RiskProfiling/assets_icons/OtherLiabilitiesIcon";
import {CLEARING_ACCOUNT_ASSET_TYPE} from "../OtherAssets/components/AssetsList/components/AssetsCategories/constants";
import {newDesignInputCustomClasses} from "../RiskProfiling/constants";

export const SERVER_ERROR = 'Bei der Verarbeitung Ihrer Anfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.';
export const LOADING_MSG = 'Daten werden synchronisiert. Bitte warten Sie einen Moment.';
export const CATEGORY_NOT_AVAILABLE = 'Diese Kategorie ist derzeit nicht verfügbar.';


export const ASSET_MODAL_TYPE_NEW = {
  EQUITY: 1,
  INSURANCE: 2,
  CASH: 3,
  IMMOBILIEN: 4,
  EXTERNAL: 5,
  LIQUID: 6,
  CRYPTO:7,
  OTHER_DEPOT: 8,
  TANGIBLE: 9,
  DEMANDS: 10,
  OTHER: 11,
  LOAN: 12,
  MORTGAGE: 13,
  CREDIT_CARD: 14,
  LEASING: 15,
  OTHER_LIABILITIES: 16,
};

export const BUILDING_SAVING_ID = 'BuildingSocietySavingsPlan';
const BUILDING_SAVING_TITLE = 'Bausparen';
export const CONSTRUCTION_LOAN_CONTRACT_ID = 'MortgageLoan';

export const EXTERNAL_CONTRACTS_IDS = new Set([BUILDING_SAVING_ID, CONSTRUCTION_LOAN_CONTRACT_ID]);

// TODO: remove "icon" and "url" if not used anymore
export const PARTICIPATION_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.EQUITY,
  title: 'Beteiligung / Firmenanteile',
  icon: images.asset_icons.equity_icon_white,
  reactIcon: <i className={'far fa-chart-pie-alt'} />,
  url: 'participation',
  subCategories: [..._.orderBy([
    {
      id: 1,
      value: '1',
      label: 'Direktinvestment'
    }, {
      id: 2,
      value: '2',
      label: 'Energiefonds'
    }, {
      id: 3,
      value: '3',
      label: 'Flugzeugfonds'
    }, {
      id: 4,
      value: '4',
      label: 'Immobilienfonds'
    }, {
      id: 5,
      value: '5',
      label: 'Infrastrukturfonds'
    }, {
      id: 6,
      value: '6',
      label: 'Medienfonds'
    }, {
      id: 7,
      value: '7',
      label: 'Mikrofinanzfonds'
    }, {
      id: 8,
      value: '8',
      label: 'Private Equity'
    }, {
      id: 9,
      value: '9',
      label: 'Fonds',
      isDefault: true,
    }, {
      id: 10,
      value: '10',
      label: 'Schiffsfonds'
    }, {
      id: 12,
      value: '12',
      label: 'Umweltfonds'
    }, {
      id: 13,
      value: '13',
      label: 'Waldfonds'
    }, {
      id: 14,
      value: '14',
      label: 'Zweitmarktfonds'
    }, {
      id: 15,
      value: '15',
      label: 'Logistikfonds'
    }, {
      id: 16,
      value: '16',
      label: 'Venture Capital'
    }
  ], 'label'), {
    id: 11,
    value: '11',
    label: 'Sonstige Spezialfonds'
  }]
};

export const INSURANCE_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.INSURANCE,
  title: 'Kapitalbildende Versicherungen',
  icon: images.asset_icons.insurance_icon_white,
  reactIcon: <i className={'fal fa-shield'} />,
  url: 'insurance',
  subCategories: [{
    id: 2,
    value: '2',
    label: 'Lebensversicherung'
  }, {
    id: 1,
    value: '1',
    label: 'Rentenversicherung'
  }, {
    id: 3,
    value: '3',
    label: 'Weitere Versicherungen',
    isDefault: true,
  }]
};

export const CALL_MONEY_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.CASH,
  title: 'Kontoguthaben',
  icon: images.asset_icons.save_cash_icon_white,
  reactIcon: <i className={'fal fa-university'} />,
  subCategories: [
    ..._.orderBy([{
      id: 1,
      value: '1',
      label: 'Girokonten'
    }, {
      id: 2,
      value: '2',
      label: 'Fest- und Tagesgelder',
      isDefault: true,
    }, {
      id: 3,
      value: '3',
      label: 'Fremdwährungskonten'
    }, {
      id: BUILDING_SAVING_ID,
      value: BUILDING_SAVING_ID,
      label: BUILDING_SAVING_TITLE
    }], 'label'
  ),
  {
    id: 5,
    value: '5',
    label: 'Weitere Kontoguthaben'
  }],
  url: 'call-money',
};

export const REAL_ESTATE_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.IMMOBILIEN,
  title: 'Immobilien',
  icon: images.asset_icons.immobilien_icon_white,
  reactIcon: <i className={'fal fa-building'} />,
  url: 'real-estate',
  subCategories: REAL_ESTATE_TYPES.map(type => ({...type, value: String(type.id)}))
};

export const EXTERNAL_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.EXTERNAL,
  title: 'Wertpapiere',
  icon:  images.asset_icons.external_icon_white,
  reactIcon: <FileInvoiceDollarIcon />,
  url: 'external',
};

export const LIQUID_ASSETS_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.LIQUID,
  title: 'Liquide Mittel',
  reactIcon: <i className={'fal fa-coins'} />,
  subCategories: [{
    id: 1,
    value: '1',
    label: 'Bargeld'
  }, {
    id: 2,
    value: '2',
    label: 'Weitere Devisen'
  }],
};

export const OTHER_FINANCIAL_CATEGORY = {
  id: 'other_financial',
  title: 'Weitere Finanzanlagen',
  reactIcon: <i className={'fal fa-briefcase'} />,
  isGroup: true, // fake category to group
  subCategories: [{
    id: ASSET_MODAL_TYPE_NEW.EXTERNAL,
    value: String(ASSET_MODAL_TYPE_NEW.EXTERNAL),
    label: 'Einzelne Wertpapiere'
  }, {
    id: ASSET_MODAL_TYPE_NEW.CRYPTO,
    value: String(ASSET_MODAL_TYPE_NEW.CRYPTO),
    label: 'Kryptowährungen'
  }, {
    id: ASSET_MODAL_TYPE_NEW.OTHER_DEPOT,
    value: String(ASSET_MODAL_TYPE_NEW.OTHER_DEPOT),
    label: 'Weitere Depots'
  }]
};

export const TANGIBLE_ASSETS_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.TANGIBLE,
  title: 'Sachvermögen',
  reactIcon: <i className={'fal fa-folder'} />,
  subCategories: [..._.orderBy([{
    id: 1,
    value: '1',
    label: 'Schmuck / Uhr'
  }, {
    id: 2,
    value: '2',
    label: 'Kunstobjekte / Antiquitäten / Sammlerstücke'
  }, {
    id: 3,
    value: '3',
    label: 'Autos / Oldtimer'
  }, {
    id: 4,
    value: '4',
    label: 'Boot / Yacht'
  }, {
    id: 5,
    value: '5',
    label: 'Flugzeug'
  }, {
    id: 6,
    value: '6',
    label: 'Weine / Spirituosen'
  }, {
    id: 7,
    value: '7',
    label: 'Edelmetalle'
  }, {
    id: 8,
    value: '8',
    label: 'Rohstoffe'
  }, {
    id: 9,
    value: '9',
    label: 'Diamanten / Edelsteine'
  }], 'label'), {
    id: 10,
    value: '10',
    label: 'Weitere Sachvermögen',
    isDefault: true,
  }]
};

export const DEMANDS_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.DEMANDS,
  title: 'Forderungen',
  reactIcon: <i className={'far fa-file-invoice-dollar'} />,
  subCategories: [{
    id: 1,
    value: '1',
    label: 'Darlehensforderungen'
  }, {
    id: 2,
    value: '2',
    label: 'Weitere Forderungen',
    isDefault: true,
  }]
};

const OTHER_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.OTHER,
  title: 'Andere Vermögenswerte',
  reactIcon: <i className={'fal fa-ellipsis-h'} />,
  defaultSubcategory: 'Sonstiges', // for sync
};


export const ASSET_CATEGORIES_V2 = [
  ..._.sortBy([
    REAL_ESTATE_CATEGORY, PARTICIPATION_CATEGORY, INSURANCE_CATEGORY, LIQUID_ASSETS_CATEGORY,
    OTHER_FINANCIAL_CATEGORY, TANGIBLE_ASSETS_CATEGORY, DEMANDS_CATEGORY, CALL_MONEY_CATEGORY
  ], 'title'),
  OTHER_CATEGORY, // others should be always last
];

export const DEPOT_ASSET_TYPE = {
  id: 'DEPOT_ASSET',
  title: 'Depots',
  reactIcon: <i className="far fa-chart-line" />,
};

export const GROUPED_ASSET_CATEGORIES = {
  [CLEARING_ACCOUNT_ASSET_TYPE.id]: CLEARING_ACCOUNT_ASSET_TYPE,
  [DEPOT_ASSET_TYPE.id]: DEPOT_ASSET_TYPE,
};
ASSET_CATEGORIES_V2.forEach((category) => {
  GROUPED_ASSET_CATEGORIES[category.id] = category;
});

export const ASSET_CONDITION_OPTIONS = [{
  id: 1,
  value: '1',
  label: 'Neu / Neuwertig'
}, {
  id: 2,
  value: '2',
  label: 'Sehr gut'
}, {
  id: 3,
  value: '3',
  label: 'Gut'
}, {
  id: 4,
  value: '4',
  label: 'Befriedigend'
}, {
  id: 5,
  value: '5',
  label: 'Mangelhaft / Reparaturbedürftig'
}, {
  id: 6,
  value: '6',
  label: 'Defekt / Nicht funktionsfähig'
}];

export const LOAN_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.LOAN,
  reactIcon: <i className={'fal fa-hand-holding-usd'} />,
  title: 'Darlehen',
  subCategories: [..._.orderBy([{
    id: 1,
    value: '1',
    label: 'Konsumentenkredit'
  }, {
    id: 2,
    value: '2',
    label: 'Immobiliendarlehen',
    disabled: true,
    disabledReason: 'Diese Kategorie ist nicht verfügbar.',
    info: 'Diese Kategorie ist nicht verfügbar.',
  }, {
    id: 3,
    value: '3',
    label: 'Autokredit'
  }, {
    id: 4,
    value: '4',
    label: 'Studienkredit'
  }, {
    id: 5,
    value: '5',
    label: 'Überbrückungskredit'
  }, {
    id: BUILDING_SAVING_ID,
    value: BUILDING_SAVING_ID,
    label: BUILDING_SAVING_TITLE
  }, {
    id: CONSTRUCTION_LOAN_CONTRACT_ID,
    value: CONSTRUCTION_LOAN_CONTRACT_ID,
    label: 'Baufinanzierung'
  }], 'label'),
  {
    id: 6,
    value: '6',
    label: 'Sonstiges'
  }]
};

export const MORTGAGE_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.MORTGAGE,
  title: 'Hypothek',
  reactIcon: <MortageIcon color={'currentColor'} />,
  subCategories: [..._.orderBy([{
    id: 1,
    value: '1',
    label: 'Haus'
  }, {
    id: 2,
    value: '2',
    label: 'Wohnung'
  }, {
    id: 3,
    value: '3',
    label: 'Grundstück'
  }], 'label'),
  {
    id: 4,
    value: '4',
    label: 'Sonstiges'
  }]
};

export const CREDIT_CARD_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.CREDIT_CARD,
  title: 'Kreditkarten',
  reactIcon: <i className={'fal fa-money-check'} />,
  subCategories: [..._.orderBy([{
    id: 1,
    value: '1',
    label: 'Charge-Kreditkarte'
  }, {
    id: 2,
    value: '2',
    label: 'Revolving-Kreditkarte'
  }, {
    id: 3,
    value: '3',
    label: 'Debit-Kreditkarte'
  }, {
    id: 4,
    value: '4',
    label: 'Prepaid-Kreditkarte'
  }], 'label'),
  {
    id: 5,
    value: '5',
    label: 'Sonstiges'
  }]
};

export const LEASING_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.LEASING,
  title: 'Leasing',
  reactIcon: <i className={'fal fa-file-signature'} />,
  subCategories: [..._.orderBy([{
    id: 1,
    value: '1',
    label: 'Fahrzeugleasing'
  }, {
    id: 2,
    value: '2',
    label: 'Maschinenleasing'
  }, {
    id: 3,
    value: '3',
    label: 'IT-Leasing'
  }, {
    id: 4,
    value: '4',
    label: 'Büroausstattungsleasing'
  }, {
    id: 5,
    value: '5',
    label: 'Immobilienleasing'
  }], 'label'),
  {
    id: 6,
    value: '6',
    label: 'Sonstiges'
  }]
};

const OTHER_LIABILITIES_CATEGORY = {
  id: ASSET_MODAL_TYPE_NEW.OTHER_LIABILITIES,
  title: 'Andere Verbindlichkeiten',
  reactIcon: <OtherLiabilitiesIcon color={'currentColor'} />,
  defaultSubcategory: 'Sonstiges' // for sync
};

export const LIABILITIES_CATEGORIES = [
  LOAN_CATEGORY, MORTGAGE_CATEGORY, CREDIT_CARD_CATEGORY, LEASING_CATEGORY, OTHER_LIABILITIES_CATEGORY
];

export const GROUPED_LIABILITIES_CATEGORIES = _.keyBy(LIABILITIES_CATEGORIES, 'id');

export const GROUPED_ASSET_AND_LIABILITY_CATEGORIES = _.merge(GROUPED_ASSET_CATEGORIES, GROUPED_LIABILITIES_CATEGORIES);

export const newDesignInputCustomClassesViewOnly = {
  ...newDesignInputCustomClasses,
  labelRoot: newDesignInputCustomClasses.labelRoot + ' ViewOnly',
  inputRoot: newDesignInputCustomClasses.inputRoot + ' ViewOnly',
  selectPlaceholder: 'ViewOnly'
};

export const ASSETS_LIABILITIES_TYPES = {
  ASSETS: 'assets',
  LIABILITIES: 'liabilities'
};

export const ASSETS_LIABILITIES_ACTIONS = {
  RE_INIT: 'reInit',
  CREATE: 'create',
  BULK_CREATE: 'bulk_create',
  UPDATE: 'update',
  DELETE: 'delete'
};

export const FILTER_OPTIONS = {
  all: {
    id: 1,
    value: 1,
    label: 'Alle',
  },
  active: {
    id: 2,
    value: 2,
    label: 'Aktive'
  },
  expired: {
    id: 3,
    value: 3,
    label: 'Abgelaufene'
  },
  future: {
    id: 4,
    value: 4,
    label: 'Zukünftige'
  }
};

export const ASSETS_LIABILITIES_CONFIG = {
  [ASSETS_LIABILITIES_TYPES.ASSETS]: {
    singleLabel: 'Vermögenswert',
    pluralLabel: 'Vermögenswerte',
    addLabel: 'Vermögenswert hinzufügen',
    linkItemLabel: 'Verbindlichkeit',
    linkItemsLabel: 'Verbindlichkeiten',
    addLinkSubHeader: 'Vorhandene Verbindlichkeit verknüpfen',
    noItemsToLinkMsg: 'Verknüpfung nicht möglich ohne vorhandene Verbindlichkeit',
    linkItemValueColor: 'red',
    confirmDeleteText: 'Möchten Sie den ausgewählten Vermögenswert wirklich löschen?',
    categories: ASSET_CATEGORIES_V2,
    noFilteredItems: {
      [FILTER_OPTIONS.active.value]: "Aktuell sind keine aktiven Vermögenswerte vorhanden.",
      [FILTER_OPTIONS.expired.value]: "Aktuell sind keine abgelaufenen Vermögenswerte vorhanden.",
      [FILTER_OPTIONS.future.value]: "Aktuell sind keine zukünftigen Vermögenswerte vorhanden.",
      [FILTER_OPTIONS.all.value]: "Aktuell sind keine Vermögenswerte vorhanden."
    },
    filterInfos: {
      [FILTER_OPTIONS.future.value]: "Hier werden Vermögenswerte angezeigt, deren Startdatum in der Zukunft liegt und die daher noch nicht aktiv sind.",
    }
  },
  [ASSETS_LIABILITIES_TYPES.LIABILITIES]: {
    singleLabel: 'Verbindlichkeit',
    pluralLabel: 'Verbindlichkeiten',
    addLabel: 'Verbindlichkeit hinzufügen',
    linkItemLabel: 'Vermögenswert',
    linkItemsLabel: 'Vermögenswerte',
    addLinkSubHeader: 'Vorhandenen Vermögenswert verknüpfen',
    noItemsToLinkMsg: 'Verknüpfung nicht möglich ohne vorhandenen Vermögenswert',
    linkItemValueColor: 'green',
    confirmDeleteText: 'Möchten Sie die ausgewählte Verbindlichkeit wirklich löschen?',
    categories: LIABILITIES_CATEGORIES,
    noFilteredItems: {
      [FILTER_OPTIONS.active.value]: "Aktuell sind keine aktive Verbindlichkeiten vorhanden.",
      [FILTER_OPTIONS.expired.value]: "Aktuell sind keine abgelaufenen Verbindlichkeiten vorhanden.",
      [FILTER_OPTIONS.future.value]: "Aktuell sind keine zukünftigen Verbindlichkeiten vorhanden.",
      [FILTER_OPTIONS.all.value]: "Aktuell sind keine Verbindlichkeiten vorhanden."
    },
    filterInfos: {
      [FILTER_OPTIONS.future.value]: "Hier werden Verbindlichkeiten angezeigt, deren Startdatum in der Zukunft liegt und die daher noch nicht aktiv sind.",
    }
  }
};